import { render, staticRenderFns } from "./ErrorChip.vue?vue&type=template&id=305b2b08&scoped=true&"
import script from "./ErrorChip.vue?vue&type=script&lang=js&"
export * from "./ErrorChip.vue?vue&type=script&lang=js&"
import style0 from "./ErrorChip.vue?vue&type=style&index=0&id=305b2b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305b2b08",
  null
  
)

export default component.exports